<template>
  <div class="d-flex w-100">
    <div class="w-15">
      <router-link
        tag="a"
        :to="`/${$i18n.locale}/design`"
        class="d-flex flex-column ai-center w-20 mt-4 back-link"
      >
        <img
          src="/assets/ic/backstage/info/ic_backstage_info_back.png"
          class="mb-1"
          alt="home"
        />
        <span>{{ $t("back") }}</span>
      </router-link>
    </div>
    <div class="flex-1">
      <div class="d-flex flex-column h-100">
        <div class="d-flex flex-column mb-6">
          <span class="mb-1">{{ $t("designEnv.title") }}</span>
          <span style="font-size: 0.85rem;">{{ $t("designEnv.content") }}</span>
        </div>
        <v-item-group v-model="selected" multiple>
          <div
            class="d-flex flex-wrap overflow-y-overlay"
            style="height: 27.5rem;"
          >
            <div
              class="mr-9 mb-5"
              v-for="(item, idx) in envs"
              :key="'envs' + idx"
            >
              <v-item v-slot:default="{ active, toggle }">
                <v-card
                  :color="active ? '#287FCE' : 'rgba(90,90,90,0.10)'"
                  class="d-flex align-center card-border"
                  height="12.5rem"
                  width="12.5rem"
                  flat
                  @click="toggle"
                >
                  <div class="flex-grow-1 text-center">
                    {{ item[envLocale] }}
                  </div>
                </v-card>
              </v-item>
            </div>
          </div>
        </v-item-group>
        <div class="p-absolute btn-fixed">
          <v-btn
            class="btn-rounded"
            color="orange"
            width="8rem"
            @click="startDesign"
            outlined
            x-large
            depressed
          >
            {{ $t("design.start") }}
          </v-btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
export default {
  computed: {
    envLocale() {
      if (this.$i18n.locale === "zh-TW") return "nameTW";
      else if (this.$i18n.locale === "zh-CN") return "nameCN";
      else if (this.$i18n.locale === "en") return "nameEN";
      return "nameTW";
    }
  },
  data() {
    return {
      selected: [],
      envs: []
    };
  },
  methods: {
    ...mapMutations("environment", ["setEnvIds"]),
    startDesign() {
      if (this.selected.length < 1) return;
      const selectedEnvs = [];
      this.selected.forEach(s => selectedEnvs.push(this.envs[s].environmentId));
      this.setEnvIds(selectedEnvs);
      if (this.$route.params.id)
        this.$router.push(
          `/${this.$i18n.locale}/design/editor/${this.$route.params.id}`
        );
      else this.$router.push(`/${this.$i18n.locale}/design/editor`);
    },
    async fetch() {
      console.log("fetch");
      const res = await this.$http.get("environments");
      console.log("fetched");
      this.envs = res.data.items;
    }
  },
  async created() {
    console.log("created");
  },
  async mounted() {
    await this.fetch();
    if (!this.$route.params.id) return;
    console.log("mounted");
    console.log("fetch design");
    const res = await this.$http.get(`design/${this.$route.params.id}`);
    console.log("fetched design");
    res.data.environmentIds.forEach(envId => {
      this.selected.push(
        this.envs.findIndex(env => env.environmentId === envId)
      );
    });

    this.setEnvIds(res.data.environmentIds);
  }
};
</script>

<style lang="sass" scoped>
.back-link
  user-select: none
  cursor: pointer
  color: #d8d8d8
  font-size: 0.85rem
  > img
    width: 1.5rem
.btn-rounded
  border-radius: 0.5rem
.btn-fixed
  right: 5.2rem
  bottom: 2.3rem
.card-border
  border: 1px solid #2980CE !important
  border-radius: 0.5rem
</style>
